/**
 * @author Brendan Magee, Iyob Beyene
 * @desc Component for redirecting users to the search view with a saved search applied
 * @example
 *          <saved-search-redirect
 *            savedSearch="savedSearch"
 *          </saved-search-redirect>
 */

import template from './savedSearchRedirect.html';

class SavedSearchRedirectController {
  constructor(
    $log,
    $state,
    $translate,
    filtersService,
    savedSearchService,
    toastWrapperService,
  ) {
    this.storyUrlPath = 'planning.list';
    this.messages = {
      loading: true,
      errorMessage: $translate.instant('ERROR_LOADING_SAVED_SEARCH_DATA'),
      savedSearchIdMissing: $translate.instant('ERROR_GETTING_REQUIRED_RESOURCE')
    };

    this.$log = $log;
    this.$state = $state;
    this.filtersService = filtersService;
    this.savedSearchService = savedSearchService;
    this.toast = toastWrapperService;
  }

  $onInit() {
    const { savedSearch } = this;
    if (savedSearch && savedSearch.params) {
      const search = this.savedSearchService.processRawSearch(savedSearch);
      const filter = this.savedSearchService.processDates(search);
      const params = this.filtersService.FilterSet.prototype.buildQueryParams.call(null, filter);
      this.$state.go(this.storyUrlPath, params);
    } else if (savedSearch === null) {
      this.messages.loading = false;
      this.toast.createToast(this.messages.savedSearchIdMissing, 'danger');
      this.$log.error('savedSearch Id is required');
    } else {
      this.messages.loading = false;
      this.$log.error(savedSearch.error);
      this.toast.createToast(this.messages.errorMessage, 'danger');
    }
  }
}

SavedSearchRedirectController.$inject = ['$log', '$state', '$translate', 'filtersService', 'savedSearchService', 'toastWrapperService', 'featureFlag'];

const savedSearchRedirect = {
  template,
  bindings: {
    savedSearch: '<'
  },
  controller: 'SavedSearchRedirectController'
};

export default function (ngModule) {
  ngModule.component('savedSearchRedirect', savedSearchRedirect);
  ngModule.controller('SavedSearchRedirectController', SavedSearchRedirectController);
}
